// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3VL6B","tab":"ProcedureTabs_tab__DBQV3"};